import type { ComponentProps, PropsWithChildren } from 'react';
import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { LeftProps, PositionProps, ResponsiveValue } from 'styled-system';
import { left, position, space } from 'styled-system';

import { useTransition } from '../../hooks/transition';
import type { SpaceProps } from '../../theme/system-types';
import { Flex } from '../Flex';
import Icon from '../Icon';

interface SubmitButtonAnimationProps extends PropsWithChildren {
  iconSize?: ResponsiveValue<number>;
}

interface WithTransitionProps {
  transition?: boolean;
}

const ButtonLabel = styled.span<WithTransitionProps>`
  opacity: 0;

  ${({ transition }) =>
    transition &&
    css`
      transition: 0.3s;
      opacity: 1;
    `}
`;

const ButtonIcon = styled(Icon)<SpaceProps & LeftProps & PositionProps & WithTransitionProps>`
  ${space};
  ${left};
  ${position};

  ${({ transition }) =>
    transition &&
    css`
      left: 0;
      transition: 0.3s;
    `}
`;

const buttonIconStyles: ComponentProps<typeof ButtonIcon> = {
  name: 'lightCheck',
  mr: 'sp_8',
  left: '70px',
  position: 'relative',
  fill: 'sys.neutral.icon.inverted',
};

const SubmitButtonAnimation = ({ iconSize = 20, children }: SubmitButtonAnimationProps) => {
  const iconTransition = useTransition(50);
  const labelTransition = useTransition(250);

  return (
    <Flex as="span" alignItems="center">
      <ButtonIcon size={iconSize} transition={iconTransition} {...buttonIconStyles} />
      <ButtonLabel role="status" aria-atomic="true" transition={labelTransition}>
        {children}
      </ButtonLabel>
    </Flex>
  );
};

export default SubmitButtonAnimation;
